module.exports = __webpack_public_path__ + "static/media/zhuyeming.722fd5e4.jpg";